import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import { doc, getDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../../store/api/fbConfig';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';

import axios from 'axios';
import { useOutletContext } from 'react-router-dom';

import {
  collection, query, where, or,getDocs
} from 'firebase/firestore';



import {
  Typography,  CircularProgress
} from '@mui/material';

import {baseURL} from "../../../store/api/Access"
import { getAuth,  } from "firebase/auth";

import DeviceHeader from '../../../components/header/DeviceHeader';
import Loader from '../../../components/other/Loader';

import {
  Box, Grid, TextField, Button, Container,
  Select, MenuItem, InputLabel, FormControl, IconButton, Divider
} from '@mui/material';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  colouredButton: {
    backgroundColor: '#19A78E',
    fontSize: '16px',
    color: '#fff',
    fontWeight: '700',
    textDecoration: 'none',
    padding: '13px',
    borderRadius: '50px',
    '&:hover': {
      backgroundColor: '#374657',
    },
  },
  clearButton: {
    fontSize: '16px',
    color: '#374657',
    fontWeight: '700',
    textDecoration: 'none',
  },
  Center: {
    textAlign: 'center',
  },
  root: {},
  Content: {
    padding: '20px 20px',
    borderBottom: '1px rgba(0, 0, 0, 0.12) solid',
  },
  textField: {
    marginBottom: '15px',
  },
  formControl: {
    marginBottom: '15px',
  },
  MenuItem: {
    color: '#8f9297',
    fontWeight: '700',
    marginRight: '10px',
    textAlign: 'left',
    '&:hover': {
      background: 'none',
      color: '#555',
    },
  },
  MenuItemSelected: {
    color: '#000',
  },
  ResponseListItem: {
    background: '#eee',
    borderBottom: '1px rgba(0, 0, 0, 0.12) solid',
  },
  deleteGrid: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    textAlign: 'right',
  },
  AddBox: {
    marginTop: '20px',
    marginBottom: '60px',
    textAlign: 'center',
  },
  AddButton: {
    padding: '10px 20px',
  },
  ResponseArray: {
    display: 'flex',
    margin: '40px 0',
  },
}));

const inputTypes = ['Variable', 'Value', 'Time', 'Date', 'submit'];

const View = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [confirmDeleteDataOpen, setConfirmDeleteDataOpen] = useState(false);
  const { userRole } = useOutletContext();

  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [deviceGroups, setDeviceGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState('');
  

  const [values, setValues] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState({});
  const [newUserEmail, setNewUserEmail] = useState('');
  const [newUserRole, setNewUserRole] = useState('viewer');
  


  

  const fetchDeviceUsers = async () => {
    try {
      const token = await getAuth().currentUser.getIdToken();
      const res = await axios.get(`${baseURL}/device/${id}/user`, {
        headers: { Authorization: token }
      });
      setUsers(res.data.users || []);
    } catch (err) {
      console.error('Failed to load users', err);
      setUsers([]);
    }
  };



  const loadAllGroups = async () => {
    const user = getAuth().currentUser;
    if (!user) return;
  
    const groupRef = collection(db, 'Groups');
    const q = query(
      groupRef,
      or(
        where('owner', '==', user.uid),
        where(`users.${user.uid}`, 'in', ['viewer', 'editor', 'admin'])
      )
    );
    const snap = await getDocs(q);
    setAllGroups(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  
  
  useEffect(() => {
    const fetchDevice = async () => {
      try {
        const ref = doc(db, 'Devices', id);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          setValues({
            name: data.name || '',
            format: data.format || 'json',
            control: data.control || [{ name: 'submit', type: 'submit' }],
            groups: data.groups || [],
          });
          setDeviceGroups(data.groups || []);
          


        }
        
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetchDevice();
    fetchDeviceUsers();
    loadAllGroups();
    

  }, [id]);

  if (loading || !values) {
    return (
      <div className={classes.root}>
        <Loader />
      </div>
    );
  }


  



  

  const handleConfirmDelete = async (event) => {
    //event.preventDefault();
    setLoading(true);
    const timeoutTimer = setTimeout(() => {
      setLoading(false);
      alert('Request timed out.');
    }, 30000);
  
    try {
      const token = await getAuth().currentUser.getIdToken();
  
      await axios.delete(`${baseURL}/device/${id}`, {
        headers: { Authorization: token },
      });
  
      clearTimeout(timeoutTimer);
      alert('Device deleted');
      setConfirmDeleteOpen(false);
      navigate('/');
    } catch (err) {
      clearTimeout(timeoutTimer);
      console.error('Failed to delete device', err);
      alert('Failed to delete device');
    } finally {
      setLoading(false);
    }
  };
  
  const handleConfirmDeleteData = async (event) => {
    event.preventDefault();
    setLoading(true);
    const timeoutTimer = setTimeout(() => {
      setLoading(false);
      alert('Request timed out.');
    }, 30000);
  
    try {
      const token = await getAuth().currentUser.getIdToken();
  
      await axios.delete(`${baseURL}/device/${id}/data`, {
        headers: { Authorization: token },
      });
  
      clearTimeout(timeoutTimer);
      alert('Device data deleted');
      setConfirmDeleteDataOpen(false);
    } catch (err) {
      clearTimeout(timeoutTimer);
      console.error('Failed to delete device data', err);
      alert('Failed to delete device data');
    } finally {
      setLoading(false);
    }
  };
  

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const ControlhandleChange = (e, index) => {
    const newControl = [...values.control];
    newControl[index] = { ...newControl[index], [e.target.name]: e.target.value };
    setValues({ ...values, control: newControl });
  };

  const controlhandleAdd = () => {
    setValues({
      ...values,
      control: [...values.control, { name: '', type: '' }],
    });
  };

  const ControlhandleDelete = (index) => {
    const newControl = [...values.control];
    newControl.splice(index, 1);
    setValues({ ...values, control: newControl });
  };

  const handleSubmit = async () => {
    try {
      await updateDoc(doc(db, 'Devices', id), {
        name: values.name,
        control: values.control,
        format: values.format || 'json',
      });
    } catch (err) {
      console.error(err);
    }
  };


  const handleRemoveUser = async (uid) => {
    try {
      const token = await getAuth().currentUser.getIdToken();
      await axios.delete(`${baseURL}/device/${id}/user/${uid}`, {
        headers: { Authorization: token }
      });
  
      const newUsers = { ...users };
      delete newUsers[uid];
      setUsers(newUsers);
       fetchDeviceUsers(); // Refresh list

    } catch (err) {
      console.error('Remove user failed', err);
      alert('Failed to remove user');
    }
  };


  const handleAddUser = async () => {
    if (!newUserEmail || !newUserRole) return;
    try {
      const token = await getAuth().currentUser.getIdToken();
      const res = await axios.post(`${baseURL}/device/${id}/user`, {
        email: newUserEmail,
        role: newUserRole
      }, {
        headers: { Authorization: token }
      });
  
      const { uid } = res.data;
      setUsers({ ...users, [uid]: newUserRole });
      setNewUserEmail('');
      setNewUserRole('viewer');
      await fetchDeviceUsers(); // Refresh list

    } catch (err) {
      console.error('Add user failed', err);
      alert('Failed to add user');
    }
  };
  
  
  const handleDelete = async () => {
    const confirm = window.confirm('Are you sure you want to delete this Device?');
    if (!confirm) return;

    try {
      await deleteDoc(doc(db,  'Devices', id));
      alert('Device deleted successfully');
      navigate('/');
    } catch (err) {
      console.error('Delete failed', err);
    }
  };

  return (
    <div className={classes.root}>

      <Box className={classes.Content}>
        <h2>General</h2>
        <TextField
          fullWidth
          label="Device name"
          name="name"
          value={values.name || ''}
          onChange={handleChange}
          variant="outlined"
          className={classes.textField}
        />
        <Button variant="contained" onClick={handleSubmit}>
          Save
        </Button>
      </Box>





      <Box className={classes.Content}>
  <h2>Groups</h2>

  {deviceGroups.length === 0 ? (
    <Typography>No groups assigned to this device.</Typography>
  ) : (
    <ul>
      {deviceGroups.map((groupId) => {
        const group = allGroups.find(g => g.id === groupId);
        return (
          <li key={groupId} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>{group ? group.name : `Group ID: ${groupId}`}</span>
            <IconButton
              onClick={async () => {
                setLoading(true);
                const newGroups = deviceGroups.filter(gid => gid !== groupId);
                await updateDoc(doc(db, 'Devices', id), { groups: newGroups });
                setDeviceGroups(newGroups);
                setLoading(false);
              }}
              size="small"
              color="error"
            >
              <HighlightOffIcon />
            </IconButton>
          </li>
        );
      })}
    </ul>
  )}

  <FormControl fullWidth sx={{ mt: 2 }}>
    <InputLabel>Select Group to Add</InputLabel>
    <Select
      value={selectedGroupId}
      onChange={(e) => setSelectedGroupId(e.target.value)}
      label="Select Group"
    >
      {allGroups
        .filter(group => !deviceGroups.includes(group.id))
        .map(group => (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        ))}
    </Select>
  </FormControl>

  <Button
    variant="contained"
    sx={{ mt: 2 }}
    disabled={!selectedGroupId}
    onClick={async () => {
      setLoading(true);
      const newGroups = [...deviceGroups, selectedGroupId];
      await updateDoc(doc(db, 'Devices', id), {
        groups: newGroups,
      });
      setDeviceGroups(newGroups);
      setSelectedGroupId('');
      setLoading(false);
    }}
  >
    Add to Group
  </Button>

  {loading && (
    <Box sx={{ mt: 2, textAlign: 'center' }}>
      <CircularProgress size={24} />
    </Box>
  )}
</Box>










      <Box className={classes.Content}>
        <h2>Response Format</h2>

        <FormControl fullWidth className={classes.formControl}>
          <InputLabel>Format</InputLabel>
          <Select
            name="format"
            value={values.format || 'json'}
            onChange={handleChange}
          >
            {['text', 'json', 'html', 'xml'].map((fmt) => (
              <MenuItem key={fmt} value={fmt}>
                {fmt.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth className={classes.formControl}>
        {(values.control || []).map((item, index) => (

            <Box key={index} className={classes.ResponseArray}>
              <Box style={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="name"
                      label="Name"
                      fullWidth
                      value={item.name || ''}
                      onChange={(e) => ControlhandleChange(e, index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Select
                      name="type"
                      value={item.type || ''}
                      onChange={(e) => ControlhandleChange(e, index)}
                      fullWidth
                      displayEmpty
                      renderValue={(selected) => selected || 'Select Control'}
                    >
                      {inputTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="value"
                      label="Value"
                      fullWidth
                      value={item.value || ''}
                      onChange={(e) => ControlhandleChange(e, index)}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Box>
                <IconButton
                  style={{ marginTop: '16px' }}
                  onClick={() => ControlhandleDelete(index)}
                >
                  <HighlightOffIcon />
                </IconButton>
              </Box>
            </Box>
          ))}

          <Box className={classes.AddBox}>
            <Button onClick={controlhandleAdd} className={classes.AddButton}>
              Add
            </Button>
          </Box>
        </FormControl>

        <Grid container spacing={2}>
  <Grid item xs={6}>
    <Button variant="contained" color="primary" onClick={handleSubmit}>
      Save
    </Button>
  </Grid>
</Grid>




      </Box>







      

<Box className={classes.Content}>
  <h2>Users</h2>


  <Button variant="contained" onClick={() => setOpenAddUserDialog(true)}>
  Add User
</Button>




  <Box mt={2}>

  {Object.values(users).map(user => (
    <Grid container spacing={1} alignItems="center" key={user.uid}>
      <Grid item xs={4}>{user.displayName}</Grid>
      <Grid item xs={4}>{user.email}</Grid>
      <Grid item xs={2}>{user.role}</Grid>
      {/*<Grid item xs={1}>
        {user.disabled ? '❌' : '✅'}
      </Grid>*/}
      <Grid item xs={1}>
        <IconButton onClick={() => handleRemoveUser(user.uid)}>
          <HighlightOffIcon fontSize="small" />
        </IconButton>
      </Grid>
    </Grid>
  ))}
</Box>


</Box>







<Dialog open={openAddUserDialog} onClose={() => setOpenAddUserDialog(false)}>
  <DialogTitle>Add User</DialogTitle>
  <DialogContent>
    <TextField
      autoFocus
      margin="dense"
      label="Email Address"
      fullWidth
      value={newUserEmail}
      onChange={(e) => setNewUserEmail(e.target.value)}
    />
    <FormControl fullWidth margin="dense">
      <InputLabel>Role</InputLabel>
      <Select
        value={newUserRole}
        onChange={(e) => setNewUserRole(e.target.value)}
        label="Role"
      >
        {['viewer', 'editor', 'admin'].map(role => (
          <MenuItem key={role} value={role}>{role}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenAddUserDialog(false)}>Cancel</Button>
    <Button
      variant="contained"
      onClick={async () => {
        await handleAddUser();
        setOpenAddUserDialog(false);
      }}
    >
      Add
    </Button>
  </DialogActions>
</Dialog>





















<Box className={classes.Content} sx={{mb:10}}>
        <h2>Device Delete</h2>


        <Grid container spacing={2}>
  <Grid item xs={6} className={classes.deleteGrid}>
    <Button
      variant="outlined"
      color="error"
      onClick={() => setConfirmDeleteDataOpen(true)}
      style={{ marginRight: '10px' }}
    >
      Delete Data
    </Button>
    <Button
      variant="contained"
      color="error"
      onClick={() => setConfirmDeleteOpen(true)}
    >
      Delete Device
    </Button>
  </Grid>
</Grid>






<Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)}>
  <DialogTitle>Delete Device</DialogTitle>
  <DialogContent>Are you sure you want to delete this device?</DialogContent>
  <DialogActions>
    <Button onClick={() => setConfirmDeleteOpen(false)}>Cancel</Button>
    <Button onClick={handleConfirmDelete} color="error">Delete</Button>
  </DialogActions>
</Dialog>

<Dialog open={confirmDeleteDataOpen} onClose={() => setConfirmDeleteDataOpen(false)}>
  <DialogTitle>Delete Device Data</DialogTitle>
  <DialogContent>Are you sure you want to delete all device data?</DialogContent>
  <DialogActions>
    <Button onClick={() => setConfirmDeleteDataOpen(false)}>Cancel</Button>
    <Button onClick={handleConfirmDeleteData} color="error">Delete</Button>
  </DialogActions>
</Dialog>

</Box>
    </div>
  );
};

export default View;
